module.exports = __webpack_public_path__ + "img/car_big.ec34d881.png";